export default __webpack_public_path__ + "static/media/_DSC0368.81b56dac.JPG";